// extracted by mini-css-extract-plugin
module.exports = {"paymentOptions":"_2S9UgOW","provider":"_3cqbUhI"};